// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'

import ConversationsList from 'syft-acp-core/entities/ConversationsList'

export const WatchlistConversationsList = () => <ConversationsList />
